import script from "./targetSignedSub.vue?vue&type=script&setup=true&lang=js"
export * from "./targetSignedSub.vue?vue&type=script&setup=true&lang=js"

import "./targetSignedSub.vue?vue&type=style&index=0&id=5a3e42b9&lang=scss"

const __exports__ = script;

export default __exports__